const { isEmpty, pick, } = require('lodash');
const dedent = require('dedent');

const { malls } = require('../config');

const { entries } = Object;

module.exports = {
  fields: () => {
    return {
      mall: {
        label: 'モール',
        type: 'select',
        options: entries(pick(malls, ['rakuten', 'yahoo', 'mercari'])).map(([k, v]) => ({ value: k, label: v.label })),
        validations: {
          required: v => v != null,
        },
      },
      name: {
        type: 'string',
        label: '店舗名',
        validations: {
          required: v => !isEmpty(v),
        },
      },
      priceRate: {
        type: 'integer',
        label: '販売価格レート(%)',
        validations: {
          greaterThan100: v => v == null || v > 100,
        },
        hint: '空の場合は130%',
      },
      rakutenServiceSecret: {
        type: 'string',
        label: '楽天 Service Secret',
        validations: {
          required: v => !isEmpty(v),
        },
        hidden: _ => _.mall !== 'rakuten',
      },
      rakutenLicenseKey: {
        type: 'string',
        label: '楽天 License Key',
        validations: {
          required: v => !isEmpty(v),
        },
        hidden: _ => _.mall !== 'rakuten',
      },
      rakutenShopUrl: {
        type: 'string',
        label: '楽天 Shop URL',
        validations: {
          required: v => !isEmpty(v),
        },
        hidden: _ => _.mall !== 'rakuten',
      },
      rakutenUsesSkuProject: {
        type: 'boolean',
        label: '楽天 SKUプロジェクト',
        hidden: _ => _.mall !== 'rakuten',
        initialValue: false,
      },
      rakutenAsurakuNumber: {
        type: 'string',
        label: '楽天 あす楽管理番号',
        hidden: _ => _.mall !== 'rakuten',
      },
      rakutenDeliveryDateId: {
        type: 'string',
        label: '楽天 納期管理番号',
        hidden: _ => _.mall !== 'rakuten',
      },
      rakutenFoldersLimit: {
        type: 'integer',
        label: '楽天 フォルダ数上限',
        hidden: _ => _.mall !== 'rakuten',
        validations: {
          required: v => v != null,
          greaterThan0: v => v > 0,
        },
        initialValue: 10000,
      },
      rakutenMailFromName: {
        type: 'string',
        label: '楽天メール 送信者名',
        hidden: _ => _.mall !== 'rakuten',
      },
      rakutenMailFromAddress: {
        type: 'string',
        label: '楽天メール 送信者アドレス',
        hidden: _ => _.mall !== 'rakuten',
      },
      rakutenMailHost: {
        type: 'string',
        label: '楽天メール ホスト名',
        hidden: _ => _.mall !== 'rakuten',
      },
      rakutenMailPort: {
        type: 'string',
        label: '楽天メール ポート番号',
        hidden: _ => _.mall !== 'rakuten',
      },
      rakutenMailUserName: {
        type: 'string',
        label: '楽天メール ユーザー名',
        hidden: _ => _.mall !== 'rakuten',
      },
      rakutenMailPassword: {
        type: 'password',
        label: '楽天メール パスワード',
        hidden: _ => _.mall !== 'rakuten',
      },
      rakutenThanksMailSubject: {
        type: 'string',
        label: '楽天受注サンクスメール 件名',
        placeholder: 'ご注文ありがとうございます',
        hidden: _ => _.mall !== 'rakuten',
      },
      rakutenThanksMailBody: {
        type: 'text',
        label: '楽天受注サンクスメール 本文',
        rows: 10,
        hint: dedent`
          {{ORDERER_NAME}} 注文者名
          {{ORDER_ID}} 注文番号
          {{ORDER_DATE}} 注文日
        `,
        hidden: _ => _.mall !== 'rakuten',
      },
      rakutenMailShippedMailTitle: {
        type: 'string',
        label: '楽天メール 発送完了メールタイトル',
        placeholder: '発送完了のお知らせ',
        hidden: _ => _.mall !== 'rakuten',
      },
      rakutenMailShippedMailBody: {
        type: 'text',
        label: '楽天メール 発送完了メール本文',
        rows: 10,
        hint: dedent`
          {{ORDERER_NAME}} 注文者名
          {{TRACKING_NUMBER}} 伝票番号
          {{CARRIER_NAME}} 配送会社名
          {{SHIPPED_DATE}} 発送日
          {{DESTINATION_POSTAL_CODE}} 送付先郵便番号
          {{DESTINATION_ADDRESS}} 送付先住所
          {{DESTINATION_NAME}} 送付先名
        `,
        hidden: _ => _.mall !== 'rakuten',
      },
      yahooClientId: {
        type: 'string',
        label: 'Yahoo Client ID',
        hidden: _ => _.mall !== 'yahoo',
      },
      yahooClientSecret: {
        type: 'string',
        label: 'Yahoo Client Secret',
        hidden: _ => _.mall !== 'yahoo',
      },
      yahooSellerId: {
        type: 'string',
        label: 'Yahoo Seller ID',
        hidden: _ => _.mall !== 'yahoo',
      },
      yahooStoreAccountName: {
        type: 'string',
        label: 'Yahoo ストアアカウント名',
        hidden: _ => _.mall !== 'yahoo',
      },
      yahooPublicKey: {
        type: 'text',
        label: 'Yahoo 公開鍵',
        hidden: _ => _.mall !== 'yahoo',
      },
      yahooPublicKeyVersion: {
        type: 'string',
        label: 'Yahoo 公開鍵バージョン',
        hidden: _ => _.mall !== 'yahoo',
      },
      yahooMailFromName: {
        type: 'string',
        label: 'Yahooメール 送信者名',
        hidden: _ => _.mall !== 'yahoo',
      },
      yahooMailFromAddress: {
        type: 'string',
        label: 'Yahooメール 送信者アドレス',
        hint: '発送通知などのFromに使うメールアドレスです。保存後、一覧の「メールドメイン認証」から別途ドメイン認証を行う必要があります（未認証の間は既定の送信元で送信されます）。',
        hidden: _ => _.mall !== 'yahoo',
      },
      yahooThanksMailSubject: {
        type: 'string',
        label: 'Yahoo受注サンクスメール 件名',
        placeholder: 'ご注文ありがとうございます',
        hidden: _ => _.mall !== 'yahoo',
      },
      yahooThanksMailBody: {
        type: 'text',
        label: 'Yahoo受注サンクスメール 本文',
        rows: 10,
        hint: dedent`
          {{ORDERER_NAME}} 注文者名
          {{ORDER_ID}} 注文番号
          {{ORDER_DATE}} 注文日
        `,
        hidden: _ => _.mall !== 'yahoo',
      },
      yahooShippedMailSubject: {
        type: 'string',
        label: 'Yahoo発送完了メール 件名',
        placeholder: '発送完了のお知らせ',
        hidden: _ => _.mall !== 'yahoo',
      },
      yahooShippedMailBody: {
        type: 'text',
        label: 'Yahoo発送完了メール 本文',
        rows: 10,
        hint: dedent`
          {{ORDERER_NAME}} 注文者名
          {{TRACKING_NUMBER}} 伝票番号
          {{CARRIER_NAME}} 配送会社名
          {{SHIPPED_DATE}} 発送日
          {{DESTINATION_POSTAL_CODE}} 送付先郵便番号
          {{DESTINATION_ADDRESS}} 送付先住所
          {{DESTINATION_NAME}} 送付先名
        `,
        hidden: _ => _.mall !== 'yahoo',
      },
      mercariToken: {
        type: 'string',
        label: 'メルカリ APIトークン',
        hidden: _ => _.mall !== 'mercari',
      },
      inventoryBuffer: {
        type: 'integer',
        label: '在庫バッファ数',
        hint: '空の場合は全体設定が使用されます',
      },
      privateListing: {
        type: 'boolean',
        label: '非公開出品',
        hint: 'チェックすると非公開で出品されます',
        initialValue: false,
      },
    };
  },
};

